const onboardingEN = {
	/* ---------- COMMON ---------- */
	showSteps: "Show steps",
	hideSteps: "Hide steps",
	stepsCompleted: "steps completed",

	/* ---------- BANNER ---------- */
	bannerTitle: "Complete your shop setup",
	bannerSubtitle: "finish to start accepting bookings",

	/* ---------- BUBBLE / HINT ---------- */
	hintTitle: "Complete your setup",
	hintText: "Finish these steps to activate your shop and start accepting bookings.",

	/* ---------- OWNER / ADMIN ---------- */
	launchShop: "Launch Shop",
	launching: "Redirecting...",
	errors: {
		billing: "We couldn't start the billing process. Please try again.",
	},
	steps: {
		shopInfo: "Shop Information",
		schedule: "Owner Schedule",
		team: "Add Your Team",
		services: "Add Services",
		images: "Upload Images",
		openingHours: "Opening Hours",
		contactInfo: "Contact Info",
		attributes: "Attributes",
	},

	/* ---------- STAFF ---------- */
	staff: {
		bannerTitle: "Complete your staff profile",
		bannerSubtitle: "finish to start accepting bookings",
		launch: "Launch Staff Profile",
		launching: "Launching...",
		steps: {
			schedule: "Employee Schedule",
			services: "Link Services",
		},
		messages: {
			success: "Staff profile activated!",
			error: "We couldn't activate your profile. Please try again.",
		},
	},
};

export default onboardingEN;